import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {StatisticState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: StatisticState = {
    statisticsDictGrouping: {
        groupBy: [],
        incomingGroupBy: [
            'hour',
            'day',
            'week',
            'month',
        ],
        incomingGroupByOptionally: [
            'recipient',
            'service_provider',
            'broker_account_login',
            'partner',
        ],
    },
    statisticGroupIncoming: undefined,
    staticGroupIncom: null,
    statisticDetailIncoming: [],
    statisticDetailIncomingFlag: undefined,
};


export const statistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
